import axios from "axios";
import { format, parseISO } from "date-fns";
import { isDate } from "lodash";
import { toast } from "react-toastify";

class Utils {
  static enviarImagem(url, formData, callBack) {
    // Recebe a url, o campo do formulario e uma funcao de callback
    // recebendo os 3 campos (progress, oQuantoJaFoi, tamanhoTotal)
    // e retorna uma Promise
    return new Promise((resolve, reject) => {
      axios
        .post(url, formData, {
          headers: { "Content-Type": "multipart/form-data" },
          onUploadProgress: (progressEvent) => {
            let progresso = progressEvent.loaded;
            let total = progressEvent.total;
            callBack(progressEvent, progresso, total); // Callback passando os valores
          },
        })
        .then((resp) => {
          resolve(resp); // Resolvido
        })
        .catch((err) => {
          reject(err); // Deu ruim :|
        });
    });
  }

  static getGrupoFil(grupos, lojas) {
    // Recebe um array grupos e um array lojas entao faz o casamento
    // dos grupos/lojas corretos e os retorna
    let grpFil = [
      "0101",
      "0102",
      "0201",
      "0301",
      "0302",
      "0401",
      "0402",
      "0501",
      "0502",
      "0601",
      "0701",
      "0702",
      "0801",
      "0901",
      "1001",
      "1002",
      "1101",
      "1102",
      "1201",
      "1301",
      "1401",
      "1402",
      "1501",
      "1601",
      "1602",
      "1701",
      "1801",
      "1901",
      "2001",
      "2101",
      "2201",
      "2301",
      "2401",
      "2501",
      "2601",
      "8001",
      "8101",
    ];
    let retorno = new Set(); // vai fazer a montagem dos grupos e filiais disponiveis
    grupos.forEach((gr) => {
      lojas.forEach((lj) => {
        // Junta grupo e loja e veja se existe no grpFil entao apenda no retorno
        let grLj =
          gr[0].toString().padStart(2, "0") + lj.toString().padStart(2, "0");

        if (grpFil.includes(grLj)) retorno.add([grLj]);
      });
    });
    return Array.from(retorno);
  }

  static divGrupoFil(grpFil) {
    // Metodo que divide o grupo e as filiais retornando um array com string grupos e string filiais
    let retorno = {
      fil: new Set(),
      gr: new Set(),
    };
    grpFil.split(",").forEach((ele) => {
      // Separa o grupo da filial
      let gr = ele.substring(0, 2);
      let fl = ele.substring(2, 4);
      retorno.gr.add(gr);
      retorno.fil.add(fl);
    });
    let arrGr = [],
      arrFl = [];
    retorno.gr.forEach((ele) => {
      arrGr.push(ele);
    });
    retorno.fil.forEach((ele) => {
      arrFl.push(ele);
    });
    return [arrGr.join(","), arrFl.join(",")];
  }
  // Metodo parqa converter celular
  static converterCelular(valor) {
    if (valor) {
      const novoValor = valor
        .replace("(", "")
        .replace(")", "")
        .replace(" ", "")
        .replace("-", "");
      const ddd = novoValor.substring(0, 2);
      const numeroParte1 = novoValor.substring(2, 7);
      const numeroParte2 = novoValor.substring(7, novoValor.length);
      return `(${ddd}) ${numeroParte1}-${numeroParte2}`;
    } else {
      return valor;
    }
  }
  // Metodo para converter os valores em monetario
  static converter(valor) {
    if (isNaN(valor)) return "R$ 0,00";
    return `R$ ${parseFloat(valor)
      .toFixed(2)
      .replace(".", ",")
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")}`;
  }
  // Metodo para desconverter um valor de real para float
  static desconverter(valor) {
    valor = valor.replace(/\./g, ""); // Substituindo ponto por nada
    valor = valor.replace(",", "."); // Substitui a virgula por ponto
    valor = valor.replace("R$", "").trim();

    return valor;
  }
  // Metodo para validar o valor esperado de uma variavel
  static validarVariavel(variaveis, variavel) {
    // Nem existe
    if (!variaveis) return false;
    // nao e um array
    if (!Array.isArray(variaveis)) return false;
    // Nao tem a variavel
    if (!variaveis.includes(variavel)) return false;

    return true;
  }
  // Metodo para converter data/hora
  static converterDataHora(valor) {
    // const [data, hora] = valor.trim().split(' ')
    // const dataRetorno =  new Date(`${data} 00:00:00`).toLocaleDateString();
    // return [dataRetorno, hora].join(' ')

    return valor
      ? format(isDate(valor) ? valor : parseISO(valor), "dd/MM/yy HH:mm")
      : valor;
  }
  // Metodo para converter o valor percentual
  static converterPercentual(valor) {
    let newValor = (valor * 100).toFixed(2);
    return isNaN(newValor) ? "0.00 %" : newValor + " %";
  }
  // Metodo para converter data
  static converterData(valor) {
    return isDate(valor)
      ? format(valor, "dd/MM/yyyy")
      : format(parseISO(valor), "dd/MM/yyyy");
    // let reg = /^[1-2][0-9][0-9][0-9]([0][1-9]|[1][0-2])([0-2][0-9]|[3][0-1])$/g;
    // let reg2 =
    //   /^[1-2][0-9][0-9][0-9]-([0][1-9]|[1][0-2])-([0-2][0-9]|[3][0-1])$/g;
    // if (reg.test(valor)) {
    //   // Regex para AAAAMMDD
    //   valor = valor.split("");
    //   let ano, mes, dia;
    //   ano = valor.splice(0, 4).join("");
    //   mes = valor.splice(0, 2).join("");
    //   dia = valor.join("");
    //   return `${dia}/${mes}/${ano}`;
    // } else if (reg2.test(valor)) {
    //   // Regex para AAAA-MM-DD
    //   valor = valor.split("-");
    //   let ano, mes, dia;
    //   ano = valor.splice(0, 1).join("");
    //   mes = valor.splice(0, 1).join("");
    //   dia = valor.join("");
    //   return `${dia}/${mes}/${ano}`;
    // }
    // return valor;
  }

  // Metodo para gravar a acao a ser registrada
  static registrarAcao(acao, rota) {
    const URL = "/acao_acionada";

    const formData = new FormData();
    formData.append(
      "dados",
      JSON.stringify({
        acao,
        rota: rota ? rota : window.location.pathname,
      })
    );

    axios
      .post(URL, formData)
      .then((resp) => {
        console.log(resp.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }
  // Metodo para buscar um aviso
  static async obterAvisoPagina() {
    const URL = "/get_aviso_por_pagina";
    const formData = new FormData();
    formData.append(
      "dados",
      JSON.stringify({ rota: window.location.pathname })
    );
    //
    try {
      const resp = await axios.post(URL, formData);
      return resp.data;
    } catch (e) {
      console.log(e);
      console.log("ERRO AO TENTAR RECUPERAR O AVISO");
    }
  }
}

// Funcao para registrar o acesso a uma pagina
export const registrarAcesso = async (rota) => {
  //{"data_acesso":"17/11/2021","hora_acesso":"17:39:01","pagina":"/atendimento_chamado","ip":"186.206.146.24"}
  const respIP = await axios.get("https://httpbin.org/ip");

  const formData = new FormData();
  formData.append(
    "dados",
    JSON.stringify({
      pagina: rota,
      ip: respIP?.data?.origin || "localhost",
    })
  );

  const resp = await axios.post("/grava_acesso", formData);
  if (resp.status !== 200) {
    console.log("ERRO INTERNO NA GRAVAÇÃO DO ACESSO");
    return false;
  }
  // Veja se tem mensagem de erro
  if (resp.data.erro) {
    console.log(resp.data.erro);
    return false;
  }
  // Tudo certo nada a se fazer
  return true;
};

export const ToastErro = (erro) => {
  toast.dark(erro, {
    type: "error",
    toastId: "ERRO",
  });
};
//
export const optTabela = {
  sxCabecalho: {
    p: 1,
    borderRadius: 0,
    backgroundColor: (theme) => theme.palette.secondary.main,
    color: (theme) => theme.palette.secondary.contrastText,
  },
  styleCabe: { fontSize: "70%" },
  styleCorpo: { fontSize: "70%", whiteSpace: "nowrap" },
  styleRodape: { fontSize: "70%", whiteSpace: "nowrap" },
  calcularRodape: true,
  baixar_em_excel: "/baixar_em_excel",
};
//
export const sxStyleContainer = {
  minHeight: "60vh",
  maxHeight: "95vh",
  overflow: "auto",
  py: 1,
};

export default Utils;
